module.exports = __webpack_public_path__ + "img/profit.2648874a.png";